module.exports = "/out/50e4cba2054209b871c0e8fbcb676650.svg";